import { faBan } from '@fortawesome/duotone-regular-svg-icons';

import { Root as StatusMessageRoot } from '../components/StatusMessage.tsx';

export function Unauthorized() {
  return (
    <StatusMessageRoot
      title="Access not authorized"
      description="You don't have permission to access Signal. Please contact your
        organization administrator to request access."
      faIcon={faBan}
    />
  );
}
